import { Radio, RadioProps } from 'antd';
import { FC } from 'react';

const DgRadioButton: FC<RadioProps> = ({ children, ...props }) => {
	return <Radio {...props}>{children}</Radio>;
};

export default DgRadioButton;
